import { withInstall } from '@ll-plus/utils'

import CheckableTag from './src/checkable-tag.vue'

export const LlCheckableTag = withInstall(CheckableTag)

export * from './src/checkable-tag'

declare module 'vue' {
  export interface GlobalComponents {
    LlCheckableTag: typeof CheckableTag
  }
}
